import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex select-none items-center justify-center gap-2 whitespace-nowrap text-p1 transition-colors [touch-action:manipulation] focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        main: 'bg-teal-500 text-white hover:bg-teal-400 active:bg-teal-400 disabled:bg-teal-200',
        headerTonal:
          'bg-teal-50 text-teal-500 hover:bg-teal-100/60 active:bg-teal-200 disabled:opacity-50',
        headerNeutral:
          'bg-slate-100 text-slate-500 hover:bg-slate-200 active:bg-slate-250 disabled:opacity-50',
        tonal:
          'bg-teal-100 text-teal-500 hover:bg-teal-200 active:bg-teal-200 disabled:bg-teal-100/50',
        additional:
          'bg-slate-300 text-white active:bg-slate-200 disabled:bg-slate-200 tablet:hover:bg-slate-250',
        secondary:
          'border-0 text-p2 text-slate-500 active:text-slate-400 tablet:hover:text-slate-300',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        secondaryOutline:
          'border border-teal-200 text-teal-500 active:border-teal-500 active:text-teal-400',
        link: 'text-primary underline-offset-4 hover:underline',
        input:
          'items-between flex-row rounded-xl border-2 border-slate-100 active:bg-slate-50',
        elongatedSquare: 'bg-white active:bg-slate-200',
      },
      size: {
        xs: '',
        sm: 'text-p rounded-small px-2 py-2 [&_svg]:size-4',
        md: 'rounded-medium px-2 py-3 text-h5 [&_svg]:size-5',
        lg: 'rounded-xl px-3 py-[18px] [&_svg]:size-6',
        l: 'rounded-large [&_svg]:size-unit-8',
        header:
          'h-11 rounded-medium px-4 text-p4 font-semibold tracking-[-0.02em] [&_svg]:size-5',
        headerMobile:
          'h-10 rounded-medium px-3 text-[14px] font-semibold tracking-[-0.02em] [&_svg]:size-5',
        headerIcon: 'size-11 rounded-medium p-0 [&_svg]:size-5',
        headerIconMobile: 'size-10 rounded-medium p-0 [&_svg]:size-5',
      },
      contentType: {
        text: '',
        onlyIcon: '',
      },
    },
    compoundVariants: [
      {
        size: 'lg',
        contentType: 'onlyIcon',
        className: 'size-12 p-0',
      },
      {
        size: 'lg',
        variant: 'secondaryOutline',
        className: 'border-2',
      },
      {
        size: 'md',
        contentType: 'onlyIcon',
        className: 'size-8 p-0',
      },
      {
        size: 'md',
        variant: 'elongatedSquare',
        className: 'px-unit-3 py-[10px] [&_svg]:size-unit-11',
      },
      {
        size: 'lg',
        variant: 'main',
        className: 'px-unit-6',
      },
    ],
    defaultVariants: {
      variant: 'main',
      size: 'lg',
      contentType: 'text',
    },
  },
);
